import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ThreePLLogRolesRBAC = {
  pageID: '342123fef85335c9ee76df5fe6ae0897',
  elementID: {
    ViewPage: '87ce4d774f70dd387909b321eba06cf5',
  },
} as const

export const useRBACThreePLLogPage = createUseRBAC(ThreePLLogRolesRBAC.elementID)

export type UseRBACThreePLLogPageType = ReturnType<typeof useRBACThreePLLogPage>
